export enum CategoryTypes {
    Award = "Award",
    Perk = "Perk",
    Benefit = "Benefit",
}

export interface Category {
    masterId: string
    createdByUser: string
    modifiedByUser: string
    createdDate: Date
    modifiedDate:Date
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    version: number
    level: number
    names: {
        [key: string]: string
    }
    parentId: string
    type: string
}

export interface PagedCategory {
    items: Category[]
    totalCount: number
}

export const CATEGORY_FIELD_LABELS: Record<string, string> = {
    names: "Naziv",
    isActive: "Aktivan",
    isDraft: "Skica",
    isDeleted: "Obrisano",
    type: "Tip",
    parentId: "Parent kategorija",
}
